/* Vision Coding - outside the email countries (snippets/vc-email-gate.liquid)
   a delivery picker lists only the posted SD card. Where the server rendered
   the hidden Email variant as the selected one - a quick view, a combo's
   option modal; the product page itself is sent to the SD card before it
   paints (vc-email-gate-head) - snippets/product-variant.liquid shows the SD
   card checked and marks the picker with data-vc-email-switch. This selects
   it through the vendor's own path, the input event on the radio, as
   vc-nbtevo-method.js does, so the price, buttons and form follow.

   Loaded from vc-email-gate-head for visitors outside the list only. The
   quick view and the option modals arrive later, so new nodes are watched. */
(function () {
  if (window.vcEmailGate) return;
  window.vcEmailGate = true;

  /* Once the vendor has the new variant it re-renders the picker, and the
     marked row goes with it. A row still on the page means the picker wasn't
     listening yet - a quick view that has only just opened ignores the first
     event - so it is tried again, a few times at most. */
  function pick(box, tries) {
    if (!box.isConnected || tries > 5) return;
    var want = box.getAttribute('data-vc-email-switch');
    var radios = box.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value !== want) continue;
      radios[i].checked = true;
      radios[i].dispatchEvent(new Event('input', { bubbles: true }));
      radios[i].dispatchEvent(new Event('change', { bubbles: true }));
      break;
    }
    setTimeout(function () { pick(box, tries + 1); }, 600);
  }

  function start(box) {
    if (box.__vcEmailSwitched) return;
    box.__vcEmailSwitched = true;
    pick(box, 0);
  }

  function scan(root) {
    if (root.matches && root.matches('[data-vc-email-switch]')) start(root);
    if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll('[data-vc-email-switch]'), start);
  }

  /* The picker only listens once the vendor's element is defined. */
  var ready = window.customElements ? customElements.whenDefined('xo-product-variants') : Promise.resolve();
  ready.then(function () {
    scan(document);
    new MutationObserver(function (records) {
      records.forEach(function (r) { Array.prototype.forEach.call(r.addedNodes, scan); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  });
})();
